import styles from './Trends.module.css'
import React from 'react'
import { NavLink } from '../ui';
import { TrendsCategoryType } from './TrendsCategoryType';
import { Iposts, Isubcatdata, ITrend } from '../../interfaces';
import { CountryCode } from '../../lib/constants';
import { TrendsProductTiles } from './TrendsProductTiles';
type props = {
    data: ITrend[],
    countryCode: CountryCode
}
export function TrendsParentCats({ data, countryCode }: props) {
    const siteURL = process.env.SITE_URL + "/" + countryCode;
    if (!data || data.length == 0) return null
       return <>
        <TrendsCategoryType data={data} />
        <div className={` ${styles.incoLivingRoom} `}>
            <div className="container">
                {data && data.map((categories: ITrend) =>
                    <div className={styles.trendsection} key={categories.cat_id}>
                        <div>
                            <div className={styles.trandsHeading}>
                                <p>
                                    <span><svg width="26" height="16" viewBox="0 0 26 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="m25.996.728-.517 5.02c-.06.551-.732.788-1.118.4l-1.224-1.23-7.708 7.754c-.484.486-1.336.486-1.82 0L9.365 8.4 2.19 15.621a1.28 1.28 0 0 1-1.814 0c-.501-.504-.501-1.322 0-1.83l8.08-8.129c.484-.487 1.336-.487 1.815 0l4.25 4.271 6.802-6.842-1.434-1.442c-.39-.392-.154-1.068.393-1.124l4.991-.52a.657.657 0 0 1 .723.723z" fill="#EB5976" />
                                    </svg></span>
                                </p>
                                    <h2 className={`${styles.trandsHead} font16 text222`}>{categories.cat_name} </h2>
                                <NavLink href={`${siteURL}/trends/category/${categories.cat_slug}`} className="link font16">View All</NavLink>
                            </div>
                            <div className={`${styles.inLivingBox} `}>
                                {categories && categories.sub_cat_data && categories.sub_cat_data.map((subcategories: Isubcatdata, idx: number) =>
                                    <React.Fragment key={idx}>
                                        {subcategories && subcategories.posts.map((posts: Iposts, idx: number) =>
                                            <TrendsProductTiles posts={posts} key={idx} subcategories={subcategories} categorySlug={categories.cat_slug} />)}
                                    </React.Fragment>)}
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    </>
}